export const drawerWidth = 270
